import { Glyph } from "../../types";

const SvgH: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" {...props}>
      <path d="M280-280v-400h80v160h240v-160h80v400h-80v-160H360v160h-80Z" />
    </svg>
  );
};

export default SvgH;
